import { Progress } from '@atom/mui';

const styleMessage = { display: 'flex', gap: '1rem', alignItems: 'center' };

const BudgetAlignLoading = () => {
  return (
    <div style={styleMessage}>
      <Progress size={30} /> Calculating your budget alignment...
    </div>
  );
};

export default BudgetAlignLoading;
